import React from 'react';

import HostActions from './HostActions';
import GuestActions from './GuestActions';
import { useEventPageContext } from './context/EventPageContext';

const EventActionBar = () => {
  const { event } = useEventPageContext();

  return (
    <>
      {event.isOrganizer || event.isScanner || event.isPhotographer ? (
        <HostActions />
      ) : (
        <GuestActions />
      )}
    </>
  );
};

export default EventActionBar;